import { render, staticRenderFns } from "./SrmDashboard.vue?vue&type=template&id=01e39564&scoped=true"
import script from "./SrmDashboard.vue?vue&type=script&lang=js"
export * from "./SrmDashboard.vue?vue&type=script&lang=js"
import style0 from "./SrmDashboard.vue?vue&type=style&index=0&id=01e39564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e39564",
  null
  
)

export default component.exports